import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Grid, Row, Col } from 'react-flexbox-grid';
import InputNumber from 'antd/lib/input-number';
import Button from 'antd/lib/button';
import Form from 'antd/lib/form';
import { getPaymentTotal } from '../../../common/utils/mathHelpers';
import {
  percentageFormatter,
  currencyFormatter,
  monthsFormatter,
} from '../../../common/utils/helpers';
import rules from '../../../common/rules/rules';
import { CalculatorSlider } from '../../../common/components';
import { InfoCreditor } from './partials';

function getInterest(interestRange, months) {
  return parseFloat(
    interestRange.find(
      interest => months > interest.termMonthsMin && months <= interest.termMonthsMax
    ).allocationInterestMax
  );
}

@translate()
@Form.create()
export default class CalculatorCreditor extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    interestRange: PropTypes.array.isRequired,
    calculatorAmountMin: PropTypes.number.isRequired,
    calculatorAmountMax: PropTypes.number.isRequired,
    calculatorAmountStep: PropTypes.number.isRequired,
    calculatorMonthsMin: PropTypes.number.isRequired,
    calculatorMonthsMax: PropTypes.number.isRequired,
    calculatorMonthsStep: PropTypes.number.isRequired,
    defaultAmount: PropTypes.number.isRequired,
    defaultMonths: PropTypes.number.isRequired,
    goToSignUp: PropTypes.func.isRequired,
    form: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    const { defaultAmount, defaultMonths, interestRange } = props;

    const currentInterest = getInterest(interestRange, defaultMonths);

    this.state = {
      amount: defaultAmount,
      months: defaultMonths,
      interest: currentInterest,
      profit: getPaymentTotal(defaultAmount, defaultMonths, currentInterest),
    };
  }

  componentDidMount(){
    if(typeof (this.props.location.state) !== 'undefined'){
      if (this.props.location.state.fromHelp === true){
        setTimeout(() => {
          this.executeScroll()
        }, 100);
      }     
    }
    
  }


  executeScroll = () => {
    console.log(this.highlight)
    console.log("executing scroll")
    let scrolling = this.highlight
    scrolling.scrollIntoView({behavior: 'smooth'})
    console.log("scrolling done")
  }



  recalculate = () => {
    const { interestRange } = this.props;
    const { amount, months } = this.state;

    const currentInterest = getInterest(interestRange, months);

    this.setState({
      interest: currentInterest,
      profit: getPaymentTotal(amount, months, currentInterest),
    });
  };

  onSliderValueChange = (val, field, min, max) => {
    let amount = val;

    if (val < min || val > max) {
      amount = val < min ? min : max;
    }

    this.props.form.setFieldsValue({ [field]: amount });
    this.setState(
      {
        [field]: amount,
      },
      this.recalculate
    );
  };

  onAmountChange = val => {
    const { calculatorAmountMin, calculatorAmountMax } = this.props;
    this.onSliderValueChange(val, 'amount', calculatorAmountMin, calculatorAmountMax);
  };

  onMonthsChange = val => {
    const { calculatorMonthsMin, calculatorMonthsMax } = this.props;
    this.onSliderValueChange(val, 'months', calculatorMonthsMin, calculatorMonthsMax);
  };

  onSliderInputBlur = field => {
    this.props.form.validateFields([field], { force: true }, (errors, values) => {
      if (!errors) {
        this.setState(
          {
            [field]: values[field],
          },
          this.recalculate
        );
      }
    });
  };

  goToSignUp = () => {
    const { goToSignUp } = this.props;
    const { amount, months, interest } = this.state;

    this.props.form.validateFields(['amount', 'months'], { force: true }, (errors, values) => {
      if (!errors) {
        goToSignUp({
          amount,
          months,
          interest,
          profit: getPaymentTotal(amount, months, interest),
        });
      }
    });
  };

  render() {
    const {
      t,
      form,
      calculatorAmountMin,
      calculatorAmountMax,
      calculatorAmountStep,
      calculatorMonthsMin,
      calculatorMonthsMax,
      calculatorMonthsStep,
      defaultAmount,
      defaultMonths,
    } = this.props;
    const { amount, months, interest, profit } = this.state;
    const { getFieldDecorator } = form;

    return (
      <div className="calculator-wrapper">
        <div className="image-placeholder">
          <Grid>
            <InfoListT />
            <section className="calculator">
              <Row between="xs" className="amount-wrapper">
                <Col xs={12} md={6} lg={7}>
                  <div className="input-number">
                    <p>{t('mám záujem investovať (€)')}</p>
                    <Form.Item>
                      {getFieldDecorator('amount', {
                        rules: [
                          ...rules.required,
                          rules.number,
                          rules.positiveNumber,
                          rules.divisibleBy(calculatorAmountStep),
                        ],
                        initialValue: defaultAmount,
                      })(
                        <InputNumber
                          size="default"
                          onBlur={() => this.onSliderInputBlur('amount')}
                          min={calculatorAmountMin}
                          max={calculatorAmountMax}
                          step={calculatorAmountStep}
                        />
                      )}
                    </Form.Item>
                  </div>
                  <CalculatorSlider
                    formatter={currencyFormatter}
                    value={amount}
                    onChange={this.onAmountChange}
                    min={calculatorAmountMin}
                    max={calculatorAmountMax}
                    step={calculatorAmountStep}
                  />
                </Col>
                <Col xs={12} md={6} lg={5} className="months-picker-wrapper">
                  <div className="input-number">
                    <p>{t('Na dobu splácania')}</p>
                    <Form.Item>
                      {form.getFieldDecorator('months', {
                        rules: [...rules.required, rules.number, rules.positiveNumber],
                        initialValue: defaultMonths,
                      })(
                        <InputNumber
                          size="default"
                          onBlur={() => this.onSliderInputBlur('months')}
                          min={calculatorMonthsMin}
                          max={calculatorMonthsMax}
                          step={calculatorMonthsStep}
                        />
                      )}
                      <p>{monthsFormatter(form.getFieldValue('months'))}</p>
                    </Form.Item>
                  </div>
                  <CalculatorSlider
                    formatter={val => monthsFormatter(val, true)}
                    onChange={this.onMonthsChange}
                    value={months}
                    min={calculatorMonthsMin}
                    max={calculatorMonthsMax}
                    step={calculatorMonthsStep}
                  />
                </Col>
              </Row>
              <ValuesT goNext={this.goToSignUp} interest={interest} profit={profit} />
            </section>
          </Grid>
        </div>
        <div ref={ (info) => {this.highlight = info}}>
          <InfoCreditor />
        </div>
      </div>
    );
  }
}

const InfoList = ({ t }) => (
  <Row className="infolist">
    <Col xs={12}>
      <h3>{t('Prečo investovať cez nás')}</h3>
      <ul>
        <li>{t('Obíďte banky a zarobte viac.')}</li>
        <li>{t('Majte zisk Vy z Vašich peňazí a nie banky.')}</li>
        <li>{t('Vyšší výnos ako pri uložených peniazoch v banke.')}</li>
        <li>{t('Moderná, bezpečná a vo svete populárna forma investovania.')}</li>
        <li>{t('Pomôžte ľuďom ako ste Vy.')}</li>
      </ul>
    </Col>
  </Row>
);

InfoList.propTypes = {
  t: PropTypes.func.isRequired,
};

const InfoListT = translate()(InfoList);

const Values = ({ t, interest, profit, goNext }) => (
  <Row center="xs" middle="xs" between="xs" className="summary">
    <Col xs={12} md={8}>
      <Row center="xs" middle="xs" around="xs">
        <Col xs={4}>
          <div>
            <div>
              <strong>{percentageFormatter(interest)}</strong>
            </div>
            <div>{t('úrok prostredníctvom Majak.sk')}</div>
          </div>
        </Col>
        <Col xs={4}>
          <div>
            <div>{t('úrok v banke')}</div>
            <div>
              <a
                href="http://banky.sk/terminovane-vklady"
                target="_blank"
                rel="noopener noreferrer"
              >
                viac info
              </a>
            </div>
          </div>
        </Col>
        <Col xs={4}>
          <div>
            <div>
              <strong>{currencyFormatter(profit)}</strong>
            </div>
            <div>{t('sa Vám vráti')}</div>
          </div>
        </Col>
      </Row>
    </Col>
    <Col xs={12} md={4}>
      <Button onClick={goNext} type="primary" size="large" className="btn-block">
        {t('Investovať')}
      </Button>
    </Col>
  </Row>
);

Values.propTypes = {
  t: PropTypes.func.isRequired,
  interest: PropTypes.number.isRequired,
  profit: PropTypes.number.isRequired,
  goNext: PropTypes.func.isRequired,
};

const ValuesT = translate()(Values);



// WEBPACK FOOTER //
// ./src/features/calculator/components/CalculatorCreditor.js